import * as THREE from 'three';

const COLORS = [0xff6b6b, 0x4ecdc4, 0xffe66d, 0xa78bfa, 0xf472b6];

/**
 * Orbes recolectables anclados al plano del target.
 * Ritmo pensado para ~50 taps en 20s en móvil (varios a la vez + respawn rápido).
 */
export class CollectibleField {
  constructor(parent, { count = 14, radius = 0.75, respawnMs = 320 } = {}) {
    this.parent = parent;
    this.count = count;
    this.radius = radius;
    this.respawnMs = respawnMs;
    this.items = [];
    this._respawnTimers = new Set();
    this.group = new THREE.Group();
    this.group.name = 'collectibles';
    parent.add(this.group);
    this._spawnAll();
  }

  _spawnAll() {
    this.clear();
    for (let i = 0; i < this.count; i += 1) {
      this.items.push(this._spawnOne(i));
    }
  }

  _spawnOne(index) {
    const color = COLORS[index % COLORS.length];
    const mesh = new THREE.Mesh(
      new THREE.SphereGeometry(0.1, 16, 16),
      new THREE.MeshStandardMaterial({
        color,
        emissive: color,
        emissiveIntensity: 0.45,
        roughness: 0.3,
        metalness: 0.2,
      }),
    );
    mesh.name = `orb-${index}`;
    mesh.userData.collectible = true;
    this._place(mesh, index);
    this.group.add(mesh);
    return mesh;
  }

  _place(mesh, seed) {
    const angle = (seed / this.count) * Math.PI * 2 + Math.random() * 0.35;
    const r = 0.22 + Math.random() * this.radius;
    mesh.position.set(Math.cos(angle) * r, 0.14 + Math.random() * 0.4, Math.sin(angle) * r * 0.55);
    mesh.visible = true;
    mesh.userData.phase = Math.random() * Math.PI * 2;
  }

  update(dt) {
    for (const mesh of this.items) {
      if (!mesh.visible) continue;
      mesh.userData.phase += dt * 3;
      mesh.position.y += Math.sin(mesh.userData.phase) * 0.0015;
      mesh.rotation.y += dt * 2;
    }
  }

  /** @returns {THREE.Object3D|null} */
  tryCollect(object) {
    let node = object;
    while (node) {
      if (node.userData?.collectible && node.visible) {
        node.visible = false;
        const captured = node;
        const timer = setTimeout(() => {
          this._respawnTimers.delete(timer);
          if (!this.group.parent) return;
          this._place(captured, Math.floor(Math.random() * this.count));
        }, this.respawnMs);
        this._respawnTimers.add(timer);
        return captured;
      }
      node = node.parent;
    }
    return null;
  }

  clear() {
    for (const timer of this._respawnTimers) clearTimeout(timer);
    this._respawnTimers.clear();
    for (const mesh of this.items) {
      this.group.remove(mesh);
      mesh.geometry?.dispose();
      mesh.material?.dispose();
    }
    this.items = [];
  }

  dispose() {
    this.clear();
    this.parent.remove(this.group);
  }
}
